<template>
  <div class="loader" v-if="loading"></div>
  <div class="announcement-holder-container">
    <div class="announcement-header">
      <h1 class="mt-4 ml-4 mb-3">Announcements</h1>
      <span>
        <button class="create-btn" @click="goToCreate">
          Create Announcement
        </button>
      </span>
    </div>
    <div class="announcement-container">
      <table id="ann-table" class="row-border" style="width: 100%; font-size: 0.9em;">
        <!-- <thead class="table-head"> -->
        <!-- <tr> -->
        <!-- <th style="width: 10%; min-width: 10%">Title</th> -->
        <!-- <th style="width: 20%; min-width: 20%">Body</th> -->
        <!-- <th style="width: 10%; min-width: 10%">Start Date</th>
            <th style="width: 10%; min-width: 10%">End Date</th>
            <th style="width: 10%; min-width: 10%">Regions</th>
            <th style="width: 10%; min-width: 10%">Status</th>
            <th style="width: 10%; min-width: 10%">Actions</th> -->
        <!-- </tr> -->
        <!-- </thead> -->
        <tbody></tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import all from '../assets/all.png';
import australia from '../assets/australia.png';
import china from '../assets/china.png';
import hongkong from '../assets/hong-kong.png';
import india from '../assets/india.png';
import japan from '../assets/japan.png';
import malaysia from '../assets/malaysia.png';
import philippines from '../assets/philippines.png';
import singapore from '../assets/singapore.png';

export default {
  data() {
    return {
      announcements: [],
      displayedAnnouncements: [],
      loading: false,
      renderedTable: '',
    };
  },
  mounted() {
    // $("ann-table").DataTable.destroy();
    this.showDatatable();
  },
  // afterMount() {
  //   $("ann-table").DataTable.destroy();
  // },
  methods: {
    showDatatable() {
      this.loading = true;
      axios
        .get(this.$hostName + '/viewAnnouncements')
        .then((response) => {
          this.announcements = response.data;
          let regionsImage = this.getRegionImage;
          this.renderedTable = $('#ann-table').DataTable({
            responsive: true,
            destroy: true,
            language: {
              searchPlaceholder: 'Enter text to search',
            },
            data: response.data,
            columns: [
              { data: 'Title', title: 'Title', width: '25%' },
              // {
              //   data: "Body",
              //   render: function (data) {
              //     const preview = data.split("..img..").join(" ").slice(0, 80);
              //     return preview.length < 80 ? data : `${preview}...`;
              //   },
              // },
              { data: 'Start Date', title: 'Start Date' },
              { data: 'End Date', title: 'End Date' },
              {
                data: null,
                title: 'Location',
                render: function (data) {
                  const regions = data.regions.map((region) => region.name);
                  const allRegions = [
                    'India',
                    'Australia',
                    'China',
                    'Hong Kong',
                    'Japan',
                    'Malaysia',
                    'Philippines',
                    'Singapore',
                  ];
                  if (allRegions.every((region) => regions.includes(region))) {
                    // return "All";
                    return (
                      '<img style="height: 30px" src="' + all + '" title="All">'
                    );
                  } else {
                    // return regions.join(", ");
                    return regionsImage(regions);
                  }
                },
                width: '30%',
              },
              {
                //this column is only to enable searching by regions hence hidden

                data: null,
                title: 'Region Names',
                visible: false, //hidden using this
                render: function (data) {
                  const regions = data.regions.map((region) => region.name);
                  const allRegions = [
                    'India',
                    'Australia',
                    'China',
                    'Hong Kong',
                    'Japan',
                    'Malaysia',
                    'Philippines',
                    'Singapore',
                  ];
                  if (allRegions.every((region) => regions.includes(region))) {
                    return 'All';
                    // return '<img style="height: 30px" src="' + all + '">';
                  } else {
                    return regions.join(', ');
                    // return regionsImage(regions);
                  }
                },
              },
              {
                data: null,
                title: 'Status',
                render: function (data) {
                  const currentDate = new Date();
                  currentDate.setHours(0, 0, 0, 0);

                  const end = new Date(data['End Date']);
                  end.setHours(0, 0, 0, 0);

                  console.log(`Now: ${currentDate} Enddate: ${end}`);
                  if (end >= currentDate) {
                    return 'Active';
                  } else {
                    return 'Inactive';
                  }
                },
              },
              {
                data: null,
                title: 'Actions',
                render: function (data, type, row) {
                  return (
                    '<button class="btn-edit" data-id="' +
                    row.id +
                    '">Edit</button>'
                  );
                },
              },
            ],
            // columnDefs: [
            //   {
            //     targets: [5, 1], // Assuming the "Status" column is at index 5 including the hidden row
            //     type: 'string',
            //     orderData: [5, 1],
            //     orderSequence: ['asc', 'desc'],
            //   },
            // ],
            order: [
                      [5, 'asc'],
                      [1, 'desc'],
                   ],
          });

          $('#ann-table').on('click', '.btn-edit', (event) => {
            const announcementId = $(event.target).data('id');

            this.$router.push({
              name: 'update-announcement',
              params: { id: announcementId },
            });
          });

          this.loading = false;
          $('#ann-table_wrapper .dataTables_length select')
    .css({
        'width': '60px',
        'margin-top': '5px' // Adjust width as needed
    });
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },

    goToCreate() {
      this.$router.push({ name: 'create-announcement' });
    },

    getRegionImage(regions) {
      let result = '';
      for (let each of regions) {
        switch (each) {
          case 'Australia':
            result = result.concat(
              `<img style="height: 30px" src="${australia}" title="Australia"> `
            );
            break;
          case 'China':
            result = result.concat(
              `<img style="height: 30px" src="${china}" title="China"> `
            );
            break;
          case 'Hong Kong':
            result = result.concat(
              `<img style="height: 30px" src="${hongkong}" title="Hong Kong"> `
            );
            break;
          case 'India':
            result = result.concat(
              `<img style="height: 30px" src="${india}" title="India"> `
            );
            break;
          case 'Japan':
            result = result.concat(
              `<img style="height: 30px" src="${japan}" title="Japan"> `
            );
            break;
          case 'Malaysia':
            result = result.concat(
              `<img style="height: 30px" src="${malaysia}" title="Malaysia"> `
            );
            break;
          case 'Philippines':
            result = result.concat(
              `<img style="height: 30px" src="${philippines}" title="Philippines"> `
            );
            break;
          case 'Singapore':
            result = result.concat(
              `<img style="height: 30px" src="${singapore}" title="Singapore"> `
            );
            break;
        }
      }
      return result;
    },
  },
};
</script>

<style scoped>
.announcement-holder-container {
  margin-bottom: 20px;
  font-family: "Montserrat";
  position: absolute;
  left: 60px;
  width: 91%;
  /* margin-right: 40px; */
}

.announcement-holder-container h2 {
  font-size: 20px;
  font-weight: bold;
}

.dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  background: white;
  border: 1px white solid;
}

div.dataTables_wrapper div.dataTables_length select {
  width: 60px !important;
  padding-inline: 10px;
}

.page-item.active .page-link:hover {
  background-color: #003976;
  border-color: #003976;
}

/* table {
  height: 100vh;
  padding: 20px;
  border: solid 1px black;
  font-size: 0.9em;
} */

.announcement-container {
  margin-left: 40px;
}

.announcement-header {
  margin-bottom: 30px;
  margin-top: 30px;
}

.create-btn {
  border: none;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 15px;
  padding-right: 15px;
  position: absolute;
  right: 0px;
  top: 40px;
  border-radius: 10px;
  background-color: rgb(71, 114, 255);
  color: white;
}

.create-btn:hover {
  background-color: #003976;
}

.btn-edit {
  padding-inline: 35px;
  padding-block: 5px;
  border-radius: 10px;
  /* background-color: none; */
  border: 1.5px solid rgb(185, 185, 185);
  background-color: rgb(253, 253, 253);
  color: black;
  /* font-size: 0.9em; */
}

.btn-edit:hover {
  background-color: rgb(221, 221, 221);
  transition: 0.5s;
}
</style>
